import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card as MuiCard, CardMedia as MuiCardMedia, CardContent as MuiCardContent, styled, Typography, } from "@mui/material";
import { Link } from "../../Link";
import { convertPxToRem } from "../../../util-functions";
import { Icon } from "../../Icon";
const StyledCard = styled(MuiCard, {
    shouldForwardProp: (prop) => prop !== "large" && prop !== "raised",
})(({ theme, large, raised }) => ({
    width: large ? convertPxToRem(320) : convertPxToRem(186),
    borderRadius: convertPxToRem(17),
    border: `solid ${convertPxToRem(1)} ${theme.palette.grey04.main}`,
    maxHeight: convertPxToRem(420),
    boxShadow: raised
        ? `0px 
       ${convertPxToRem(20)} 
       ${convertPxToRem(40)} 0px rgba(0, 0, 0, 0.10), 
       0px 
       ${convertPxToRem(4)} 
       ${convertPxToRem(12)} 
       ${convertPxToRem(-2)} rgba(0, 0, 0, 0.10)`
        : "none",
}));
const StyledCardMedia = styled(MuiCardMedia, {
    shouldForwardProp: (prop) => prop !== "large",
})(({ large }) => ({
    height: large ? convertPxToRem(170) : convertPxToRem(128),
}));
const StyledCardContent = styled(MuiCardContent)(() => ({
    padding: `${convertPxToRem(20)} ${convertPxToRem(16)} !important`,
}));
const StyledCardText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "maxRows",
})(({ maxRows }) => ({
    display: "-webkit-box",
    WebkitLineClamp: maxRows,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: 0,
}));
const StyledContentTextContainer = styled("div")(() => ({
    marginTop: convertPxToRem(4),
    marginBottom: convertPxToRem(12),
    // metadata, tile, & description are separated by 4px
    p: {
        marginTop: convertPxToRem(4),
    },
    // last text element has a bottom margin of 4px
    // dynamic because the last element could be the title or the description
    "*:last-child": {
        marginBottom: convertPxToRem(12),
    },
}));
const StyledLinkContainer = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    marginBottom: convertPxToRem(4),
    a: {
        marginRight: convertPxToRem(4),
    },
}));
export const MediaCard = ({ description, large = false, linkProps, mediaProps, metaData, raised = false, testId, title, }) => (_jsxs(StyledCard, Object.assign({ raised: raised, large: large, "data-testid": testId }, { children: [_jsx(StyledCardMedia, { image: mediaProps.image, title: mediaProps.title, large: large, "data-testid": testId && `${testId}-media` }), _jsxs(StyledCardContent, Object.assign({ "data-testid": testId && `${testId}-content-container` }, { children: [_jsxs(StyledContentTextContainer, Object.assign({ "data-testid": testId && `${testId}-static-content-container` }, { children: [metaData && (_jsx(StyledCardText, Object.assign({ variant: "largeCapitalizedTextStrong", paragraph: true, "data-testid": testId && `${testId}-metadata`, maxRows: large ? "1" : "2", color: "secondaryText.main" }, { children: metaData.join(" • ") }))), _jsx(StyledCardText, Object.assign({ variant: large ? "h6" : "mediumTextStrong", paragraph: true, "data-testid": testId && `${testId}-title`, maxRows: "3" }, { children: title })), description && (_jsx(StyledCardText, Object.assign({ variant: large ? "mediumText" : "smallText", paragraph: true, "data-testid": testId && `${testId}-description`, maxRows: "4" }, { children: description })))] })), _jsxs(StyledLinkContainer, { children: [_jsx(Link, Object.assign({}, linkProps, { variant: "largeTextStrong", testId: testId && `${testId}-link` })), _jsx(Icon, { iconName: "ArrowRight", color: "green10", fontSize: "small", testId: testId && `${testId}-arrowRight-icon` })] })] }))] })));
